<template>
  <NoteSection
    label="Change in Patient Health"
    required
    :highlight-required="isSectionIncomplete"
    :form-validated="formValidated"
  >
    <auto-complete-box
      v-model="health_change"
      :items="healthChanges"
      label="Change in Patient Health"
      class="col-sm-12"
      required
    ></auto-complete-box>
    <text-area
      v-if="health_change === 'Other'"
      v-model="health_change_other"
      class="col-sm-12"
      label="Enter change in patient health..."
      counter="7000"
      maxlength="7000"
      required
    ></text-area>
  </NoteSection>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    value: {
      type: String,
      default: null,
    },
    healthChangeOther: {
      type: String,
      default: null,
    },
    formValidated: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      health_change: this.value,
      health_change_other: this.healthChangeOther,
    }
  },
  computed: {
    ...mapGetters('encounters', ['healthChanges']),
    // Checks if the required values are empty
    isSectionIncomplete() {
      if (!this.health_change) return true
      if (this.health_change === 'Other' && !this.health_change_other) return true
      return false
    },
  },
  watch: {
    health_change() {
      this.$emit('input', this.health_change)
    },
    health_change_other() {
      this.$emit('update:health-change-other', this.health_change_other)
    },
  },
  methods: {
  },
}
</script>